// Normalize only chart measures; labels, IDs, and dates retain their original types.
export function toStatisticNumber(value) {
  if (typeof value !== 'number' && typeof value !== 'string') {
    return 0;
  }

  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
}
